import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { AdminFilterService } from './admin-filter.service';
import { ApiEnvelope, SalesforceCaseListData } from '@core/models';

/**
 * Admin API client for Salesforce Support_Request__c cases (GET /admin/cases).
 */
@Injectable({ providedIn: 'root' })
export class SalesforceCasesService {
  private readonly api = inject(ApiService);
  private readonly filters = inject(AdminFilterService);

  /**
   * GET /admin/cases — Lithia support requests from Salesforce, scoped by
   * AdminFilterService range and optional search.
   */
  getCases(search: string): Observable<ApiEnvelope<SalesforceCaseListData>> {
    const params = this.filters.queryParams();
    const qs = new URLSearchParams();
    if (search.trim()) qs.set('search', search.trim());
    qs.set('range', params.range);
    if (params.from) qs.set('from', params.from);
    if (params.to) qs.set('to', params.to);
    return this.api.get<SalesforceCaseListData>(`/admin/cases?${qs.toString()}`);
  }
}
